/**
 * @Author: Jon Lucas
 * @Date:   2017-09-11T14:41:41+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-29T17:28:44+02:00
 */

import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { BuildingCustomizationComponent } from "./main-view/building-customization/building-customization.component";
import { RoofDimensionsComponent } from "./main-view/roof-dimensions/roof-dimensions.component";
import { SurelevationDimensionsComponent } from "./main-view/surelevation-dimensions/surelevation-dimensions.component";
import { ContactFormComponent } from "./main-view/contact-form/contact-form.component";
import { EndOfStudyComponent } from "./main-view/end-of-study/end-of-study.component";
import { CheckButtonListComponent } from "./main-view/check-button-list/check-button-list.component";
import { BelrivDimensionsComponent } from "./main-view/belriv-dimensions/belriv-dimensions.component";
import { FullScreenComponent } from "./full-screen/full-screen.component";
import { AuthenticationComponent } from "./authentication/authentication.component";
import { AccessoriesComponent } from "./main-view/accessories/accessories.component";


const routes: Routes = [

    { path: "authentication/:token", component: AuthenticationComponent },
    { path: "view/fullscreen", component: FullScreenComponent },

    { path: "lang/:lang/contact-information/end-of-study", component: EndOfStudyComponent },
    { path: "lang/:lang/contact-information/contact-form", component: ContactFormComponent },
    { path: "lang/:lang/contact-information/", redirectTo: "lang/:lang/contact-information/contact-form" },

    { path: "lang/:lang/installation-and-accessories/belriv-dimensions", component: BelrivDimensionsComponent },
    { path: "lang/:lang/installation-and-accessories/wall-profile-type", component: CheckButtonListComponent },
    { path: "lang/:lang/installation-and-accessories/crochet-type", component: CheckButtonListComponent },
    { path: "lang/:lang/installation-and-accessories/accessories-type", component: AccessoriesComponent },
    { path: "lang/:lang/installation-and-accessories/installation-type", component: CheckButtonListComponent },

    { path: "lang/:lang/building/roof-dimensions", component: RoofDimensionsComponent },
    { path: "lang/:lang/building/surelevation-dimensions", component: SurelevationDimensionsComponent },

    { path: "lang/:lang/project-finalisation/save-configuration-type", redirectTo: "lang/fr/project-finalisation/save-configuration-type" },

    { path: "lang/:lang/:type/:subtype", component: BuildingCustomizationComponent },

    // Leave end slashes (/) to avoid main view refresh when setting or resetting the subtype
    { path: "", redirectTo: "lang/fr/project-type-choice/", pathMatch: "full" },
    { path: "**", redirectTo: "lang/fr/project-type-choice/" }

];

@NgModule({
    imports: [RouterModule.forRoot(routes,  { enableTracing: false }) /* <-- debugging purposes only)*/ ],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts